export default {
      id: "Icon--locationHotspotCircle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--locationHotspotCircle",
      toString: function () {
        return this.url;
      }
    }